import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6" }
const _hoisted_3 = {
  key: 0,
  class: "error-field"
}
const _hoisted_4 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6" }
const _hoisted_5 = {
  key: 0,
  class: "error-field"
}
const _hoisted_6 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6" }
const _hoisted_7 = {
  key: 0,
  class: "error-field"
}
const _hoisted_8 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6" }
const _hoisted_9 = {
  key: 0,
  class: "error-field"
}
const _hoisted_10 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6" }
const _hoisted_11 = {
  key: 0,
  class: "error-field"
}
const _hoisted_12 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6" }
const _hoisted_13 = {
  key: 0,
  class: "error-field"
}
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_15 = {
  key: 0,
  class: "error-field"
}
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_17 = {
  key: 0,
  class: "error-field"
}
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_19 = { class: "checkbox" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Acconsento al trattamento dei dati personali ai sensi del D.LGS. n. 196/03 e GDPR 679/2016 come indicato nei ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.iubenda.com/privacy-policy/43785160/full-legal",
  class: "iubenda-nostyle no-brand iubenda-embed iub-legal-only iub-no-markup",
  title: "Privacy Policy"
}, "Termini e condizioni di utilizzo del servizio", -1)
const _hoisted_22 = { class: "checkbox" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Acconsento a che Marlù S.p.A con sede legale in San Marino, Via M.Bucci, 55 Domagnano utilizzi i miei recapiti, anche telefonici e di posta elettronica per finalità di profilazione, per l'invio di offerte, sconti, promozioni e di omaggi, inviti a manifestazioni a premio personalizzate ed attinenti ai miei interessi e per effettuare ricerche di mercato volte a migliorare la qualità del servizio offerto? Selezionando \"Non acconsento\" non si consentirà a Marlù S.p.A. di comunicarle sconti, promozioni, offerte, inviti e altre iniziative riservate agli utenti registrati. ")
const _hoisted_24 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-4" }
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "contact-us-form",
    onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.name) = $event)),
          class: "form-control",
          name: "name",
          placeholder: "Nome*",
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.model.name]
        ]),
        (_ctx.v$.name.$invalid && _ctx.v$.name.$dirty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.lastname) = $event)),
          class: "form-control",
          name: "lastname",
          placeholder: "Cognome*",
          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.model.lastname]
        ]),
        (_ctx.v$.lastname.$invalid && _ctx.v$.lastname.$dirty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.email) = $event)),
          class: "form-control",
          name: "email",
          placeholder: "Email*",
          onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.model.email]
        ]),
        (_ctx.v$.email.$invalid && _ctx.v$.email.$dirty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.telephone) = $event)),
          class: "form-control",
          name: "telephone",
          placeholder: "Telefono*",
          onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.model.telephone]
        ]),
        (_ctx.v$.telephone.$invalid && _ctx.v$.telephone.$dirty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.province) = $event)),
          class: "form-control",
          name: "province",
          placeholder: "Provincia*",
          onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.model.province]
        ]),
        (_ctx.v$.province.$invalid && _ctx.v$.province.$dirty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.city) = $event)),
          class: "form-control",
          name: "city",
          placeholder: "Città*",
          onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.model.city]
        ]),
        (_ctx.v$.city.$invalid && _ctx.v$.city.$dirty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.organizationName) = $event)),
          class: "form-control",
          name: "organizationName",
          placeholder: "Azienda*",
          onInput: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.model.organizationName]
        ]),
        (_ctx.v$.organizationName.$invalid && _ctx.v$.organizationName.$dirty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.type) = $event)),
          class: "form-control",
          name: "type",
          placeholder: "Settore merceologico*",
          onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.model.type]
        ]),
        (_ctx.v$.type.$invalid && _ctx.v$.type.$dirty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_17))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _withDirectives(_createElementVNode("textarea", {
          class: "form-control",
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.notes) = $event)),
          rows: 5,
          placeholder: "Note"
        }, null, 512), [
          [_vModelText, _ctx.model.notes]
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "policy",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.model.policy) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.model.policy]
          ]),
          _hoisted_20,
          _hoisted_21
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "terms",
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.model.terms) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.model.terms]
          ]),
          _hoisted_23
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          type: "submit",
          disabled: _ctx.v$.$invalid,
          class: "btn btn-primary float-end text-uppercase btn-custom-store-locator"
        }, " Invia ", 8, _hoisted_25)
      ])
    ])
  ], 32))
}